<template>
    <div class="car-wrap">
        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-6">
            <div :data-id="car.id" :class="isActive">
                <div class="row">
                    <div class="col-sm-9 col-xs-12 omega" :data-id="car.id" @click="showModal">
                        <div class="image" :style="{ 'background-image': 'url(images/ATK_Fahrzeugillus/aktiv/' + car.name + '.png)' }"></div>
                    </div>
                    <div class="col-sm-3 col-xs-12 alpha">
                        <div class="col-sm-12 col-xs-6 year" :data-id="car.id" @click="showYearModal">
                            <span :class="yearHintClass">
                                <i :class="yearIconClass" aria-hidden="true"></i>
                            </span>
                            <p class="text-center">
                                <i class="fa fa-spinner fa-spin" v-if="loadingTypes"></i>
                                <span v-if="!loadingTypes">BJ</span>
                            </p>
                        </div>
                        <div class="col-sm-12 col-xs-6 type" :data-id="car.id" @click="showTypeModal">
                            <span :class="typeHintClass">
                                <i :class="typeIconClass" aria-hidden="true"></i>
                            </span>
                            <p class="text-center">
                                <i class="fa fa-spinner fa-spin" v-if="loadingCategories"></i>
                                <span v-if="!loadingCategories">TYP</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row" :data-id="car.id" @click="showModal">
                    <div class="col-sm-12">
                        <div class="model">
                            <p class="text-center">{{ car.name }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <model-year :years="car.children" :car-id="car.id"></model-year>
        <model-type :types="carTypes" :car-id="car.id"></model-type>
    </div>
</template>

<script>

import _ from 'lodash';

export default {

    props: {
        car: {
            required: true
        }
    },

    data() {
        return {
            carTypes: [],
            model: null,
            year: null,
            type: null,
            loadingTypes: false,
            loadingCategories: false
        }
    },

    methods: {

        showModal(e) {
            this.year ? this.showTypeModal(e) : this.showYearModal(e);
        },

        showYearModal({currentTarget}) {
            App.event.fire(
                'car.open.years',
                currentTarget.dataset.id
            );                
        },

        showTypeModal({currentTarget}) {
            App.event.fire(
                'car.open.types',
                currentTarget.dataset.id
            );                
        },

    },

    computed: {

        yearHintClass() {
            return this.year ? 'hint-success hint' : 'hint-danger hint';
        },

        yearIconClass() {
            return this.year ? 'fa fa-check' : 'fa fa-question';
        },

        typeHintClass() {
            return this.type ? 'hint-success hint' : 'hint-danger hint';
        },

        typeIconClass() {
            return this.type ? 'fa fa-check' : 'fa fa-question';
        },

        isActive() {
            return this.year ? 'car active' : 'car';
        }

    },

    created() {

        App.event.listen('car.types.loaded', ({types, car}) => {
            this.loadingTypes = false;
            this.carTypes = (car == this.car.id) ? types : [];
        });

        App.event.listen('car.brand.selected', () => {
            this.year = null;
            this.type = null;
        });

        App.event.listen('car.year.selected', ({year, car}) => {
            if (car == this.car.id) {
                this.loadingTypes = true;
                this.year = year;
                this.type = null;
            } else {
                this.year = null;
                this.type = null;
            }
        });

        App.event.listen('car.type.selected', ({type, car}) => {
            this.type = (car == this.car.id) ? type : null;
            this.loadingCategories = (car == this.car.id);
        })

        App.event.listen('car.categories.loaded', () => 
            this.loadingCategories = false
        );

        App.event.listen('car.selection.ready.cars', selection => {

            if (selection.types) {
                let year = Object.keys(selection.types).pop();
                let hasCar = _.findKey(this.car.children, child => {
                    return child.id == year;
                });

                if (hasCar) {
                    this.year = year;
                    this.carTypes = selection.types[this.year];
                }
            }
            if (selection.categories) {
                let type = Object.keys(selection.categories).pop();
                let year = Object.keys(selection.types).pop();
                let hasCar = _.findKey(this.car.children, child => {
                    return child.id == year;
                });

                if (hasCar) {
                    this.type = type;                    
                }
                
            }
        });

    },
    
}
</script>
